<template>
    <div>
        <div id="recruitment-page">
            <div class="row">
                <div class="col-12">
                    <div class="shadow-radius">
                        <div class="ttl">
                            درخواست همكاري
                        </div>
                        <p class="blue">
                            جهت ثبت و به جريان افتادن فرم مذكور خواهشمند است پس از مطالعه دقيق، فرم را تكميل نمائيد.
                        </p>
                        <!-- Form -->
                        <form-wizard shape="circle"
                                     color="#1ba583 "
                                     title=""
                                     subtitle=""
                                     errorColor="#ff2929"
                                     id="recruitment-form">
                            <tab-content title="اطلاعات اولیه" icon='1' :before-change="()=>validateStep('step1')">
                                <step1 ref="step1" @on-validate="mergePartialModels"></step1>
                            </tab-content>
                            <tab-content title="تحصیلات" icon='2' :before-change="()=>validateStep('step2')">
                                <step2 ref="step2" @on-validate="mergePartialModels" v-if="windowWidth >=600"></step2>
                                <step2-mobile ref="step2" @on-validate="mergePartialModels" v-if="windowWidth <600"></step2-mobile>
                            </tab-content>
                            <tab-content title="فعالیت‌هاو مهارت‌ها" icon='3' :before-change="()=>validateStep('step3')">
                                <step3 ref="step3" @on-validate="mergePartialModels" v-if="windowWidth >=600"></step3>
                                <step3-mobile ref="step3" @on-validate="mergePartialModels" v-if="windowWidth <600"></step3-mobile>
                            </tab-content>
                            <tab-content title="سایر اطلاعات" icon='4' :before-change="()=>validateStep('step4')">
                                <step4 ref="step4" @on-validate="mergePartialModels" v-if="windowWidth >=600"></step4>
                                <step4-mobile ref="step4" @on-validate="mergePartialModels" v-if="windowWidth <600"></step4-mobile>
                            </tab-content>
                            <tab-content title="بررسی و ثبت نهایی" icon='5'>
                                <div v-if="passModel">
                                    <step5 :finalModel="finalModel" v-if="windowWidth >=600"></step5>
                                    <step5-mobile :finalModel="finalModel" v-if="windowWidth <600"></step5-mobile>
                                </div>
                            </tab-content>
                            <!-- Form Buttons-->
                            <template slot="footer" slot-scope="props">
                                <div class=wizard-footer-right>
                                    <wizard-button v-if="props.activeTabIndex > 0" class="btn-prev" @click.native="props.prevTab()"><span class="avafont-arrow-right"></span>مرحله قبل</wizard-button>
                                </div>
                                <div class="wizard-footer-left">
                                    <wizard-button v-if="!props.isLastStep" @click.native="props.nextTab()" class="wizard-footer-right">مرحله بعد<span class="avafont-arrow-left"></span></wizard-button>
                                    <wizard-button v-else @click.native="postForm" class="wizard-footer-right finish-button">ثبت نهایی<span class="avafont-checkmark"></span></wizard-button>
                                </div>
                            </template>
                        </form-wizard>
                        <div id="recruitment-loading" v-if="loading">
                            <div class="loader">
                                <div class="page-loading">
                                    <div></div>
                                    <div></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { FormWizard, TabContent, WizardButton } from 'vue-form-wizard';
    import { mapActions } from 'vuex';
    import Step1 from "./Step1.vue";
    import Step2 from "./Step2.vue";
    import Step3 from "./Step3.vue";
    import Step4 from "./Step4.vue";
    import Step5 from "./Step5.vue";
    import Step2Mobile from "./Step2Mobile.vue";
    import Step3Mobile from "./Step3Mobile.vue";
    import Step4Mobile from "./Step4Mobile.vue";
    import Step5Mobile from "./Step5Mobile.vue";
    export default {
        components: {
            FormWizard,
            TabContent,
            WizardButton,
            Step1,
            Step2,
            Step3,
            Step4,
            Step5,
            Step2Mobile,
            Step3Mobile,
            Step4Mobile,
            Step5Mobile
        },
        data() {
            return {
                finalModel: { },
                passModel: false,
                loading: false,
                props: {
                    title: {
                        type: String,
                        default: ''
                    },
                    subtitle: {
                        type: String,
                        default: ''
                    }
                },
            };
        },
        created() {
            window.addEventListener(
                'resize',
                this.$store.commit('setWindowWidth')
            )
        },
        computed: {
            windowWidth() {
                return this.$store.state.windowWidth;
            },
            basedOnWindowWidth() {
                if (this.windowWidth > 768) {
                    return true;
                } return false;
            }
        },
        methods: {
            ...mapActions({
                createRecruitmentForm: "recruitment/createRecruitmentForm",
            }),
            validateStep(name) {
                var refToValidate = this.$refs[name];
                var validate = refToValidate.validate();
                if (name == 'step4' && validate) {
                    this.passModel = true;
                };
                return validate;
            },
            mergePartialModels(model, isValid) {
                if (isValid) {
                    // merging each step model into the final model
                    this.finalModel = Object.assign({}, this.finalModel, model);
                } else {
                    this.$swal({
                        text: 'برای رفتن به مرحله بعد لطفا تمامی فیلدهای مشخص شده را به دقت پرکنید.',
                        icon: 'warning',
                        showConfirmButton: false,
                    });
                }
            },
            postForm() {
                this.loading = true;
                this.createRecruitmentForm(this.finalModel).then(r => {
                    this.$swal({
                        position: 'center-center',
                        icon: 'success',
                        text: 'اطلاعات شما با موفقیت ثبت شد،از ابراز تمايل شما براي همكاري با شركت فناوران آواسیس متشكريم.',
                        showConfirmButton: false,
                        timer: 8000
                    });
                    this.loading = false;
                }).catch(e => {
                    this.$swal({
                        position: 'center-center',
                        icon: 'error',
                        text: e.request.response,
                        showConfirmButton: false,
                        timer: 8000
                    });
                    this.loading = false;
                });
            }
        }
    };
</script>